import { CHANGE_THEME } from '../AC';

export default (previousState = 'light', { type, payload }) => {
	if (type === CHANGE_THEME) {
		return payload;
	}
	return localStorage.getItem('theme') || previousState;
};
